import { useEffect, useState } from "react";
import styles from "./notification.module.scss";
import Cross from "@assets/icons/cross.svg";

type NotificationProps = {
  id: number;
  message: string;
  remove: (id: number) => void;
};

const Notification: React.FC<NotificationProps> = ({ id, message, remove }) => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    setIsVisible(true);
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 5000); // Disappears after 5 seconds
    return () => clearTimeout(timer); // Cleanup timeout if component unmounts
  }, []);
  // Remove the notification from state after the transition ends
  const handleTransitionEnd = () => {
    if (!isVisible) {
      remove(id);
    }
  };
  return (
    <div
      className={`${styles.notification} ${!isVisible ? styles.notificationHidden : ""}`}
      onTransitionEnd={handleTransitionEnd}
    >
      {message}
      <Cross onClick={() => setIsVisible(false)} className={styles.close} />
    </div>
  );
};

export default Notification;
